import React from 'react';
import { Select } from 'antd';
import { Trans } from 'react-i18next';

const { Option } = Select;

const CoccidiostatosFilter = props => {

  const handerCoccidiostatos = coccidiostatosSelected => {
    props.setCoccidiostatos( coccidiostatosSelected )
  }

  return (
    <div className="filter initialCoccidiostatos">
      <div className="tag"> <Trans>{ props.type === 'initial' ? 'Initial Feed applied coccidiostat' : 'Final Feed applied coccidiostat' }</Trans> </div>
      <div className="selector">
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Please select"
          value={ props.coccidiostatos }
          onChange={ handerCoccidiostatos }
        >
          { props.list.map( p => {
            return <Option key={ p._id } value={ p._id } > { p.nombre } </Option>
          } ) }
        </Select>
        <div className="noneAllSelector">
          <div className="all" onClick={ () => { props.setCoccidiostatos( props.list.map( p => p._id ) ) } }> <Trans>Select All</Trans> </div>
          <div className="separator"> | </div>
          <div className="none" onClick={ () => { props.setCoccidiostatos( [] ) } }> <Trans>None</Trans> </div>
        </div>
      </div>
    </div>
  )

}

export default CoccidiostatosFilter
